import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { Multiline } from '~/components/Multiline';
import { WidgetContentEmpty } from '~/components/WidgetContentEmpty/WidgetContentEmpty';

export interface SupplierIntroductionContentProps {
  data: { text: string; language: string };
  loading: boolean;
}

export const SupplierIntroductionContent = ({ data, loading }: SupplierIntroductionContentProps) => {
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'NegotiationSupplierIntroductionWidget' });

  return (
    <>
      {loading || data.text === '' ? (
        <WidgetContentEmpty title={t('empty')} />
      ) : (
        <Typography variant="body1">
          <Multiline>{data.text}</Multiline>
        </Typography>
      )}
    </>
  );
};
